export default "__VITE_ASSET__650efe3b__"